"use client"

import { Clock, Fuel, Gauge, Waves } from "lucide-react"

import { SectionContainer } from "@shared/ui/landing/section-container"

import { trc20Advantages, trc20Meta } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

const advantageIcons = {
  speed: Gauge,
  fees: Clock,
  energy: Fuel,
  liquidity: Waves,
} as const

export function Trc20Section() {
  const t = useTranslations("trc20")

  return (
    <SectionContainer id="trc20">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-brand">{t("title")}</h2>
        <p className="mt-3 text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {trc20Advantages.map((id) => {
          const Icon = advantageIcons[id]
          const meta = trc20Meta[id]
          return (
            <div
              key={id}
              className="rounded-2xl border border-brand bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-brand">{t(`${id}.title`)}</h3>
                  <p className="mt-1 text-xs font-medium text-emerald-700">{meta.value}</p>
                </div>
                <Icon className="size-5 text-brand/60" />
              </div>
              <p className="mt-4 text-sm text-muted-foreground">{t(`${id}.description`)}</p>
            </div>
          )
        })}
      </div>
    </SectionContainer>
  )
}
